import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, ApiError } from './api';
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const refresh = useCallback(async () => {
        try {
            const { user } = await api.get('/auth/me');
            setUser(user);
        }
        catch (e) {
            if (!(e instanceof ApiError) || e.status !== 401)
                console.error('auth refresh', e);
            setUser(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    const logout = useCallback(async () => {
        await api.post('/auth/logout').catch(() => { });
        setUser(null);
    }, []);
    useEffect(() => { void refresh(); }, [refresh]);
    return (_jsx(Ctx.Provider, { value: { user, loading, refresh, logout, setUser }, children: children }));
}
export function useAuth() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error('AuthProvider missing');
    return v;
}
